// extracted by mini-css-extract-plugin
export default {"wrapper":"RadioGroup_wrapper__SsZmW","option":"RadioGroup_option__7zwpD","active":"RadioGroup_active__QWe6I"};